import { format, differenceInMinutes } from 'date-fns'

const fromForm = formValues => {
  const startsAtDate = format(formValues.startsAtDate, 'yyyy/M/d')
  const startsAt = `${startsAtDate} ${formValues.startsAtTime}`
  const endsAt = `${startsAtDate} ${formValues.endsAtTime}`

  const duration = differenceInMinutes(new Date(endsAt), new Date(startsAt))
  const timeable = getTimeable(formValues)
  const { id, type } = timeable

  return {
    timeableId: id,
    timeableType: type,
    startsAt: startsAt,
    duration: duration,
    virtual: formValues.type === 'doctor' ? !!formValues.virtual : false,
    notes: formValues.notes || null,
  }
}

const getTimeable = values => {
  switch (values.type) {
    case 'clinic':
      const clinicId =
        typeof values.clinicId === 'object'
          ? values.clinicId?.id
          : values.clinicId
      return { id: clinicId, type: 'Clinic' }
    case 'room':
      return { id: values.roomId, type: 'Room' }
    case 'doctor':
      return { id: values.doctorId, type: 'Doctor' }
    default:
      return {}
  }
}

export default fromForm
